import { render, staticRenderFns } from "./FormStaticRender.vue?vue&type=template&id=5721c95c&scoped=true"
import script from "./FormStaticRender.vue?vue&type=script&lang=js"
export * from "./FormStaticRender.vue?vue&type=script&lang=js"
import style0 from "./FormStaticRender.vue?vue&type=style&index=0&id=5721c95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721c95c",
  null
  
)

export default component.exports